import 'jq/req/mobilefix';
import 'jq/req/eutils';
import 'jq/req/ga';
import 'jq/req/x/cookie';
import 'jq/req/onformatchange';
import 'jq/req/mobilemenu';
import 'jq/req/autovalidate';
import 'jq/req/anchortags';
import 'jq/req/listscroller';
import 'jq/req/whenonscreen';
import 'jq/req/x/hammer-1.1';
import 'jq/req/prettynum';
import './_js/owl.carousel.min.js';
import 'jq/req/sharebtns';

import cfg from './config.json';

window.jQuery(function($) {
	'use strict';

	const $html = $('html');

	const lang = document.documentElement.lang;

	const $win = $(window);
	// var $body = $( 'body' );
	const $doc = $(document);

	const formatMonitor = $.formatChange(window.FormatChange.makeGroups(cfg.mediaFormats));
	const media = formatMonitor.media;
	// console.log('formatMonitor', formatMonitor);
	// console.log('media', media);

	const i18n = { en: {} };
	i18n.is = $.beget(i18n.en);
	const txt = i18n[$('html').attr('lang')] || i18n.en;

	// =========================================================================================================================
	//   Default Configs
	// =========================================================================================================================

	// =========================================================================================================================
	//   Actions
	// =========================================================================================================================

	// var noop = $.noop;

	const tagFileAndExternalLinks = function() {
		i18n.en.newWindow = 'Opens in new window';
		i18n.is.newWindow = 'Opnast í nýjum vafraglugga';
		i18n.en.fileText = 'file';
		i18n.is.fileText = 'skjal';

		$('a:not(.videolink)').anchorTags({
			usePatterns: ['doc', 'pdf', 'xls'],
			// localDomains: ['\\.*.eplica.is','\\.*.domain.is'],
			onTag: function(link, is) {
				const text = is.pattern
					? is.pattern[0].toUpperCase() + ' ' + txt.fileText
					: is.external
					? txt.newWindow
					: '';
				text &&
					link
						.attr('target', '_blank')
						.attr('title', $.trim(link.attr('title') || link.text()) + ' (' + text + ')');

				if (link.find('img').length) {
					link.addClass('has-image');
				}

				const gaCat = is.external
					? 'external'
					: is.tel
					? 'telephone'
					: is.mailto
					? 'email'
					: is.pattern
					? 'download'
					: '';
				if (window.ga && gaCat) {
					link.on('click', function(/*e*/) {
						window.gaHXM.eventPing(
							gaCat,
							is.pattern ? 'click-' + is.pattern[0] : 'click',
							link.attr('href').replace(/^(tel|mailto):/i, ''),
							1,
							is.external ? true : false
						);
					});
				}
			},
		});
	};

	const _collapseCollapseBlocks = function(article) {
		article.find('.collapse').each(function() {
			const head = $(this).addClass('collapse-active collapse-closed');
			head
				.nextUntil('h2, .collapse, hr, .buttons, .share-widgets')
				.wrapAll('<div class="collapseouter" style="display: none" />')
				.wrapAll('<div class="collapsebox" />');

			const converttext = $(this)
				.text()
				.replace('á', 'a')
				.replace('é', 'e')
				.replace('ó', 'o')
				.replace('ú', 'u')
				.replace('í', 'i')
				.replace('æ', 'ae')
				.replace('ö', 'o')
				.replace('þ', 'th')
				.replace(' ', '-')
				.toLowerCase()
				.replace(/[^A-Z0-9]/gi, '');
			$(this).attr('data-title', converttext);

			head.wrapInner('<a href="#" />').on('click', function(e) {
				head
					.toggleClass('collapse-closed')
					.next()
					.slideToggle('fast');

				if ($(this).is('.collapse-closed')) {
					$.setFrag('');
				} else {
					$.setFrag($(this).data('title'));
				}

				e.preventDefault();
			});
		});

		//console.log('GetFrag: ', $.getFrag());
		const url = document.location.href;
		const idx = url.indexOf('#');
		const hash = idx !== -1 ? url.substring(idx + 1) : '';
		if (hash.length > 0) {
			const currentCollapse = article.find('.collapse[data-title=' + hash + ']');
			if (currentCollapse.length > 0) {
				setTimeout(
					function() {
						currentCollapse.click();
						//console.log('scroll', $(currentCollapse).offset().top);
						const top = $(currentCollapse).offset().top;

						$('html, body').animate(
							{
								scrollTop: top,
							},
							1000
						);
					},
					500,
					top
				);
			}
		}
	};

	const _injectShareBtns = function(article) {
		const list = $('<ul class="social__sharing" />');
		list
			.sharebtns({
				wrap: 'li',
				custom: true,
				// countNone: true,
				twitter: 2,
				// gplus:     2,
				// pinterest: 3,
				fbshare: 1,
				facebook: false,
				linkedin: true,
			})
			.end();

		article.find('.article__image').before(list);
	};

	const prepArticleContent = function() {
		$('.section--article, .section--collapse').each(function() {
			const article = $(this);
			_collapseCollapseBlocks(article);
		});

		const articleNews = $('.article--frettir');
		if (articleNews.length > 0) {
			_injectShareBtns(articleNews);
		}
	};

	const initForms = function() {
		$('form').autoValidate({
			errorMsgType: 'inlineonly',
			validateEachField: 'change',
		});
	};

	const handleTelephoneLinks = function() {
		// depends on formatChange()
		i18n.is.callPrompt = 'Hringja í ';
		i18n.en.callPrompt = 'Call ';
		$doc.on('click', 'a[href^="tel:"]', function(e) {
			if (media.isLarge) {
				const m = $(this)
						.text()
						.match(/\+?\d[\s\-\d]+\d/),
					num = (m && m[0]) || this.href.substr(4);
				if (!confirm(txt.callPrompt + num + ' ?')) {
					e.preventDefault();
				}
			}
		});
	};

	const initCookieBanner = function initCookieBanner() {
		const cookieText =
			'<span>Þessi vefur notar vafrakökur til notkunarmælinga.</span><a href="/personuvernd" class="disclaimer-btn disclaimer-btn--close">Samþykkja</a><a href="/personuvernd" class="disclaimer-btn">Sjá nánar</a>';

		if (!$.cookie('privacynotify')) {
			const $privacyBanner = $(
				'<div class="disclaimer">' + cookieText + '</div>'
			).appendTo('body');
			$privacyBanner.on('click', '.disclaimer-btn--close', function(e) {
				e.preventDefault();
				$html.removeClass('show-disclaimer');
				$privacyBanner.remove();
				$.cookie('privacynotify', '1', { expires: 365, path: '/' });
			});
			setTimeout(function() {
				$html.addClass('show-disclaimer');
			}, 1200);
		}
	};

	// initCookieBanner(); // Ekki notað lengur

	// const quotes = function() {
	// 	const $quoteList = $('.quotes__boxbody');
	// 	if ($quoteList && $quoteList.find('.quotes__item').length > 1) {
	// 		$quoteList.hammer().listscroller({
	// 			item: '.quotes__item',
	// 			stepSize: 1,
	// 			windowSize: 1,
	// 			wrap: 'start',
	// 			paging: false,
	// 			jumpPager: true,
	// 			overflow: 'hidden',
	// 			statusPager: false,
	// 			animation: 'carousel',
	// 			statusLabel: 'Step: ',
	// 		});
	// 	}
	// };

	const _owl = (
		selector,
		itemsSmall,
		itemsLarge,
		margin,
		stagePaddingSmall,
		stagePaddingLarge,
		autoplay
	) => {
		const $itemCarousel = selector.find('.item');
		if ($itemCarousel.length > 1) {
			selector.addClass('owl-carousel').owlCarousel({
				transitionStyle: 'fade',
				autoplay: autoplay,
				dots: true,
				loop: true,
				nav: false,
				smartSpeed: 800,
				info: true,
				singleItem: true,
				navText: ['<span>&#x2039;Next</span>', '<span>&#x203a;Prev</span>'],
				responsiveClass: true,
				responsive: {
					0: {
						stagePadding: stagePaddingSmall,
						items: itemsSmall,
					},
					960: {
						items: itemsLarge,
						stagePadding: stagePaddingLarge,
						margin: margin,
					},
				},
				onInitialized: function(e) {
					const $cont = $(e.target);
					$cont.find('[role]').removeAttr('role');
					$cont.find('.owl-item').attr('aria-hidden', 'true');
					$cont.find('.owl-item.active').removeAttr('aria-hidden');
					$cont.find('.cloned > [id]').removeAttr('id');
				},
				onChanged: function(e) {
					const $cont = $(e.target);
					setTimeout(function() {
						$cont.find('.owl-item').attr('aria-hidden', 'true');
						$cont.find('.active').removeAttr('aria-hidden');
					}, 50);
				},
			});
			let i = 1;
			$('.carousel .owl-dot').each(function() {
				$(this)
					.text(i)
					.prepend('0');
				i++;
			});
		}
	};

	const events = () => {
		const $events = $('.event__wrapper .boxbody');
		if ($events || !$events === null) {
			_owl($events, 1, 1, 1, false, false, true);
		}
	};

	const quotes = () => {
		const $quotes = $('.quotes .quotes__boxbody');
		if ($quotes || !$quotes === null) {
			_owl($quotes, 1, 1, 1, false, false, false);
		}
	};

	const heroBanner = function() {
		const $hero = $('.hero');
		const $heroImg = $hero.find('.hero__image');
		if ($html.is('.home')) {
			$heroImg.each(function() {
				const $this = $(this);
				$win
					.on('formatchange', function() {
						if (media.becameSmall) {
							$this.css({
								'background-image': 'url(' + $this.attr('data-imgsmall') + ')',
							});
						} else if (media.isLarge) {
							$this.css({
								'background-image': 'url(' + $this.attr('data-imglarge') + ')',
							});
						}
					})
					.trigger('formatchange');
			});
		}
	};

	const search = function() {
		const $qsearch = $('.qsearch');
		const $searchBtn = $qsearch.find('.qsearch__btn');
		const $searchInput = $qsearch.find('input');
		if (lang !== 'is') {
			$searchInput.attr('placeholder', 'Search here');
		} else {
			$searchInput.attr('placeholder', 'Hverju ertu að leita að?');
		}
		$searchBtn.on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			$(this).toggleClass('search-on');
			$html.toggleClass('search-open');

			if ($(this).is('.search-on')) {
				setTimeout(function() {
					$searchInput.focusHere();
					$searchInput.attr('aria-disabled', 'false');
				}, 500);
			}
		});

		$qsearch.on('click', function(e) {
			e.stopPropagation();
		});

		$html.on('click', function() {
			if ($html.is('.search-open')) {
				$searchBtn.trigger('click');
				$searchInput.attr('aria-disabled', 'true');
			}
		});

		$win.on('keyup', function(e) {
			if (e.which === 27 && $html.is('.search-open')) {
				$searchBtn.trigger('click');
				$searchInput.attr('aria-disabled', 'true');
			}
		});
	};

	const initBlockAnimations = () => {
		const $contentblocks = $('.observe');
		if ($contentblocks.length) {
			const ranges =
				media.format === 'wide'
					? { top: '-15%s', bottom: '-5%s' }
					: media.isHeaderLarge
					? { top: '-10%s', bottom: '-5%s' }
					: { top: '-5%s', bottom: '-2%s' };
			setTimeout(function() {
				$contentblocks
					.whenOnScreen({
						live: true,
						ranges: { visible: ranges },
					})
					.on('whenonscreen', function() {
						$(this)
							.addClass('onscreen')
							.off('whenonscreen');
					});
			}, 10);
		}

		const $contentListItems = $('.contentlist .contentlist__item');
		if ($contentListItems.length) {
			$contentListItems
				.whenOnScreen({ live: true, ranges: '-10%s' })
				.on('whenonscreen', function() {
					$(this).addClass('visible');
				});
		}
	};

	function _prettyNum(upph) {
		return $.prettyNum.make(upph);
	}

	const calculator = () => {
		const jsonUrl =
			'https://flm-prod-benefits-calculator-func.azurewebsites.net/api/CalculateBenefits';
		//'https://flm-prod-benefits-calculator-func-staging.azurewebsites.net/api/CalculateBenefits';
		//'https://flm-prod-benefits-calculator-func.azurewebsites.net/api/CalculateBenefits';

		// const tempData = [
		// 	{
		// 		monhtlyLifeInsuranceBenefit: 500,
		// 		monthlyHealthInsuranceBenefit: 700,
		// 		monthlySalaryInsuranceBenefit: 900,
		// 	},
		// ];

		const calculatorForm = document.querySelector('.calculator');

		const jsonUrlV2 =
			'https://flm-prod-benefits-calculator-func.azurewebsites.net/api/v2/CalculateBenefits';
		const calculatorFormV2 = document.querySelector('.calculatorv2');

		if (calculatorForm) {
			const calculatorFormBtn = document.querySelector('#calculator-button');
			const calculatorAge = document.querySelector('#age');
			const calculatorSalary = document.querySelector('#salary');

			$('#salary').on('keyup', function() {
				$(this).liveVal(_prettyNum(this.value));
			});

			calculatorFormBtn.addEventListener('click', function(e) {
				e.preventDefault();

				$html.addClass('calculator__showResults calculating');

				const postData = {
					age: calculatorAge.value,
					monthlySalary: calculatorSalary.value.replace(/[\s.,]+/g, '').trim(),
				};

				fetch(jsonUrl, {
					method: 'POST',
					body: JSON.stringify(postData),
					headers: { 'Content-type': 'application/json; charset=UTF-8' },
				})
					.then((response) => response.json())
					.then((json) => {
						document.getElementById('liftrygging').innerHTML = _prettyNum(
							json.monthlyLifeInsuranceBenefit
						);
						document.getElementById('sjukratrygging').innerHTML = _prettyNum(
							json.monthlyDiseaseInsuranceBenefit
						);
						document.getElementById('sjukratryggingin').innerHTML = _prettyNum(
							json.monthlyMedicalDisabilityInsuranceBenefit
						);
						document.getElementById('sjukdomatrygging').innerHTML = _prettyNum(
							json.monthlyDiseaseInsuranceBenefitChildren
						);
						document.getElementById('launatrygging').innerHTML = _prettyNum(
							json.monthlySalaryInsuranceBenefit
						);
						//$html.addClass('calculator__showResults');
						$html.removeClass('calculating');
					})
					.catch((err) => {
						console.log(err);
						alert('Í augnablikinu næst ekki samband við vefþjón.');
					});
			});
		}

		if (calculatorFormV2) {
			const calculatorFormBtn = document.querySelector('#calculator-button');
			const calculatorAge = document.querySelector('#age');
			const calculatorSalary = document.querySelector('#salary');

			$('#salary').on('keyup', function() {
				$(this).liveVal(_prettyNum(this.value));
			});

			calculatorFormBtn.addEventListener('click', function(e) {
				e.preventDefault();

				$html.addClass('calculator__showResults calculating');

				const postData = {
					age: calculatorAge.value,
					monthlySalary: calculatorSalary.value.replace(/[\s.,]+/g, '').trim(),
				};

				fetch(jsonUrlV2, {
					method: 'POST',
					body: JSON.stringify(postData),
					headers: { 'Content-type': 'application/json; charset=UTF-8' },
				})
					.then((response) => response.json())
					.then((json) => {
						document.getElementById('liftrygging').innerHTML = _prettyNum(
							json.monthlyLifeInsuranceBenefit
						);
						document.getElementById('sjukratrygging').innerHTML = _prettyNum(
							json.monthlyDiseaseInsuranceBenefit
						);
						document.getElementById('sjukratryggingin').innerHTML = _prettyNum(
							json.monthlyMedicalDisabilityInsuranceBenefit
						);
						document.getElementById('sjukdomatrygging').innerHTML = _prettyNum(
							json.monthlyDiseaseInsuranceBenefitChildren
						);
						document.getElementById('launatrygging').innerHTML = _prettyNum(
							json.monthlySalaryInsuranceBenefit
						);
						document.getElementById('slysatrygging').innerHTML = _prettyNum(
							json.monthlyAccidentInsuranceBenefit
						);
						//$html.addClass('calculator__showResults');
						$html.removeClass('calculating');
					})
					.catch((err) => {
						console.log(err);
						alert('Í augnablikinu næst ekki samband við vefþjón.');
					});
			});
		}
	};

	const langSetting = () => {
		if (lang !== 'is') {
			$html.addClass('lang-en');
		}

		const langSwitcher = document.querySelector('.langswitcher');
		if (langSwitcher) {
			const languages = langSwitcher.querySelectorAll('.langswitcher__language');
			languages.forEach((language) => {
				if (language.getAttribute('lang-attr') === lang) {
					language.classList.add('current');
				} else {
					language.classList.remove('current');
				}
			});

			langSwitcher.addEventListener('click', function(e) {
				$html.toggleClass('show-lang');
			});

			$win.on('keyup', function(e) {
				if (e.which === 27 && $html.is('.show-lang')) {
					langSwitcher.trigger('click');
					langSwitcher.attr('aria-disabled', 'true');
				}
			});
		}
	};

	// remove opened class from all Chart sectors
	const closeAllSectors = (doughnut) => {
		doughnut.find('.doughnut__sector').each(function() {
			const targetName = $(this).data('name');
			doughnut.find(`[data-name="${targetName}"]`).removeClass('opened');
			$(this).removeClass('opened');
		});
	};

	const doughnutChartInit = () => {
		const hoverSector = function(e, targetName) {
			const target = $(e.currentTarget);

			target.addClass('hovered');
			target
				.closest('.doughnut')
				.find(targetName)
				.addClass('hovered');
		};

		const mouseLeaveSector = function(e, targetName) {
			const target = $(e.currentTarget);

			target.removeClass('hovered');
			target
				.closest('.doughnut')
				.find(targetName)
				.removeClass('hovered');
		};

		// manage open state on click
		const clickSector = function(e, dataNameAttr) {
			const target = $(e.currentTarget);
			const chart = target.closest('.chart');
			const els = chart.find(dataNameAttr);

			if (target.hasClass('opened')) {
				els.removeClass('opened');
			} else {
				closeAllSectors(chart);
				els.addClass('opened');

				// scroll to the opened accordion item on mobile
				const accordion = chart.find(`.accordion${dataNameAttr}`);
				if (media.format !== 'wide' && !target.is(accordion)) {
					$('html, body').animate(
						{
							scrollTop: accordion.offset().top - 150,
						},
						500
					);
				}
			}
		};

		$('.chart').each(function() {
			const chart = $(this);
			const allCharts = chart.find('.doughnut__sector__svg g');
			const allAccordions = chart.find('.accordion');

			// linked svg doughnut chart
			// and text content on desktop, accordion items on mobile
			// via data-name
			chart.find('.doughnut__sector').each(function(index) {
				const chartName = `doughtnut-chart-${Math.random() + index}`;
				const attrDataName = `[data-name="${chartName}"]`;
				const orderNumber = { '--i': `${index}` };

				$(this)
					.attr('data-name', chartName)
					.css(orderNumber);
				$(allCharts[index])
					.attr('data-name', chartName)
					.css(orderNumber);
				$(allAccordions[index])
					.attr('data-name', chartName)
					.css(orderNumber);

				$(this).hover(
					(e) => hoverSector(e, attrDataName),
					(e) => mouseLeaveSector(e, attrDataName)
				);
				$(allCharts[index]).hover(
					(e) => hoverSector(e, attrDataName),
					(e) => mouseLeaveSector(e, attrDataName)
				);

				$(this).on('click', (e) => clickSector(e, attrDataName));
				$(allCharts[index]).on('click', (e) => clickSector(e, attrDataName));
				$(allAccordions[index]).on('click', (e) => clickSector(e, attrDataName));
			});

			// add close buttons to popups
			chart.find('.doughnut__sector__popup').each(function() {
				const closeBtn = $(
					'<button type="button" class="doughnut__sector__popupClose" />'
				);
				closeBtn.on('click', function() {
					const sector = $(this).closest('.doughnut__sector')[0];
					const sectorName = $(sector).attr('data-name');
					$(this)
						.find(`[data-name="${sectorName}"]`)
						.removeClass('opened');
				});
				$(this).append(closeBtn);
			});
		});
	};

	const updateDoughnutChart = (chart, activeUnion) => {
		// update text inside the circle
		const title = $(chart).find('.doughnut__grid__title')[0];
		const activeUnionText = $(title).data(activeUnion);
		$(title)
			.find('.bigger')
			.text(activeUnionText);

		// assign class name to the svg chart
		// and text content on desktop and accordion item on mobile
		// depending on the active union
		$(chart)
			.find('.doughnut__sector')
			.each(function() {
				const sector = $(this);
				const sectorName = sector.data('name'); // the same name as svg chart and accordion item have
				const attrDataName = `[data-name="${sectorName}"]`;
				const chartData = $(chart).find(attrDataName);
				const chartG = $(chart).find(`g${attrDataName}`);

				if (
					activeUnion !== 'flm' &&
					sector.data('union') &&
					activeUnion !== sector.data('union')
				) {
					chartData.addClass('excluded');
					chartData.removeClass('included');
				} else {
					chartData.addClass('included');
					chartData.removeClass('excluded');
				}

				// applying styles to the included sectors when its non-flm union
				activeUnion !== 'flm'
					? chartG.addClass('featured')
					: chartG.removeClass('featured');
			});

		// update text inside the chart on mobile
		const chartUnion = $(chart).attr('data-union');
		const mobileTitle = $(chart).find('.doughnut__grid__titleMobile');
		const mobileTitleText = $(mobileTitle).data(chartUnion);
		$(mobileTitle).text(mobileTitleText);
	};

	const unionSwitcher = () => {
		$('.chart__switcher__input').each(function() {
			const switcher = $(this);
			const chart = switcher.closest('.chart');
			const label = switcher.siblings('label')[0];
			// Enter key handler
			label &&
				label.addEventListener('keydown', (e) => {
					if (e.key === 'Enter') {
						switcher.click();
					}
				});

			switcher.on('change', function() {
				const isChecked = switcher.is(':checked');
				const activeUnion = isChecked ? 'other' : 'flm';
				// add active union as a data-attr of the section
				chart.attr('data-union', activeUnion);

				updateDoughnutChart(chart, activeUnion);

				// close all sectors, accodrions and charts on switch
				closeAllSectors(chart);
			});
		});
	};

	calculator();
	// var boxWrapperHelper = function () {
	//   const bWrapper = document.querySelectorAll('.box-wrapper');
	//   bWrapper.forEach(function(itm) {
	//     itm.style.background = 'rgba(0,0,0,.3)'
	//     const bbody = itm.querySelector('.boxbody');
	//     bbody.style.background = 'rgba(215, 40, 40, 0.5)'
	//   })
	// }
	/*
	const initCookieConsent = function() {
		$.cookieConsent.lang.en['disclaimer-Intro'] =
			'This website uses cookies to measure traffic.';
		$.cookieConsent.lang.is['disclaimer-Intro'] =
			'Þessi vefur mælir umferð um vefinn með vafrakökum.';
		$.cookieConsent.lang.en['disclaimer-Accept'] = 'Accept';
		$.cookieConsent.lang.is['disclaimer-Accept'] = 'Samþykja';
		$.cookieConsent.lang.en['disclaimer-Deny'] = 'Deny';
		$.cookieConsent.lang.is['disclaimer-Deny'] = 'Hafna';
		$.cookieConsent.lang.en['myConsent-trackers'] = 'Google Analytics and Facebook Pixel';
		$.cookieConsent.lang.is['myConsent-trackers'] = 'Google Analytics og Facebook Pixel';
		$.cookieConsent.lang.en['disclaimer-PrivacyPolicy-LinkText'] = 'See more';
		$.cookieConsent.lang.is['disclaimer-PrivacyPolicy-LinkText'] = 'Sjá nánar';

		$.cookieConsent({
			privacyPolicyTempl:
				'<a class="button" href="%{privacyPolicyLink}">%{privacyPolicyLinkText}</a>',
		});
	};
	*/
	// =========================================================================================================================
	//   Run Init Actions
	// =========================================================================================================================

	$('ol').attr('data-oltype', function() {
		return this.type || '';
	}); // enable fancy styling on <ol> markers....

	tagFileAndExternalLinks(); // Þarf að keyrast soldið seint vegna ga tracking
	$('table:not(table table)').wrap('<div class="tablewrap" />');

	prepArticleContent();
	initForms();
	events();
	quotes();
	search();
	heroBanner();
	unionSwitcher();
	doughnutChartInit();
	langSetting();

	// initCookieConsent();
	// boxWrapperHelper();
	initBlockAnimations();

	$.initMobileMenu({
		mediaGroup: 'HeaderSmall',
		stickyHeader: false,
		resetScroll: false,
	});

	$.initStickyHeader({
		mediaGroup: 'HeaderSmall',
		headerHeight: function() {
			return parseInt(
				window.getComputedStyle(document.documentElement).getPropertyValue('padding-top')
			);
		},
	});

	handleTelephoneLinks(); // <- depends on formatChange

	$('html').removeClass('beforejsinit loading'); //remove flicker trick
	$win.on('beforeunload', function() {
		$html.addClass('loading');
	});

	$.fixSkiplinks && $.fixSkiplinks();
});
